import { relations, sql } from 'drizzle-orm'
import {
  check,
  decimal,
  index,
  integer,
  pgEnum,
  pgTable,
  text,
  uniqueIndex,
} from 'drizzle-orm/pg-core'
import { getBaseFields, getBaseIndexes, getIdReference } from '../common/utils'
import { employees } from './employee'

// Remote areas are meant to be served on their rotation day only. A flex area
// is in nobody's rotation: an empty own day moves there, as an availability
// row, when a customer the search could not otherwise serve books it.
export const serviceAreaKindEnum = pgEnum('service_area_kind', [
  'core',
  'remote',
  'flex',
])

export const serviceAreas = pgTable(
  'service_areas',
  {
    ...getBaseFields(),
    name: text().notNull(),
    kind: serviceAreaKindEnum().notNull().default('core'),
    latitude: decimal({ precision: 10, scale: 8 }).notNull(),
    longitude: decimal({ precision: 11, scale: 8 }).notNull(),
    // How far from the centre a customer may be; null = the preset's limit.
    maxDrivingMinutes: integer(),
  },
  (table) => [
    ...getBaseIndexes('service_areas', table),
    check(
      'service_areas_max_driving_minutes_check',
      sql`${table.maxDrivingMinutes} > 0`,
    ),
  ],
)

// One cell of an employee's repeating rotation: on this weekday of this
// rotation week the day's availability starts from the area's centre.
export const employeeRotationDays = pgTable(
  'employee_rotation_days',
  {
    ...getBaseFields(),
    employeeId: getIdReference(() => employees.id),
    // 0-based week of the rotation, see employees.rotationWeeks
    weekIndex: integer().notNull(),
    // ISO weekday, 1 = Monday … 7 = Sunday
    weekday: integer().notNull(),
    serviceAreaId: getIdReference(() => serviceAreas.id),
  },
  (table) => [
    ...getBaseIndexes('employee_rotation_days', table),
    index('employee_rotation_days_employee_id_idx').on(table.employeeId),
    uniqueIndex('employee_rotation_days_employee_week_day_idx')
      .on(table.employeeId, table.weekIndex, table.weekday)
      .where(sql`${table.deletedAt} IS NULL`),
    check(
      'employee_rotation_days_weekday_check',
      sql`${table.weekday} BETWEEN 1 AND 7`,
    ),
    check(
      'employee_rotation_days_week_index_check',
      sql`${table.weekIndex} >= 0`,
    ),
  ],
)

export const employeeRotationDaysRelations = relations(
  employeeRotationDays,
  ({ one }) => ({
    employee: one(employees, {
      fields: [employeeRotationDays.employeeId],
      references: [employees.id],
    }),
    serviceArea: one(serviceAreas, {
      fields: [employeeRotationDays.serviceAreaId],
      references: [serviceAreas.id],
    }),
  }),
)
